import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("title", function () {
        return [
          _c("div", { staticClass: "text-body-2 text-secondary--text mb-2" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Запись на приём", _setup.options)) +
                "\n    "
            ),
          ]),
        ]
      }),
      _vm._v(" "),
      _c(
        VRadioGroup,
        {
          staticClass: "mt-0 pt-0",
          attrs: {
            value: _setup.t(
              _setup.doctorFiltersState.visitLocation,
              _setup.options
            ),
            "hide-details": "",
            column: "",
            mandatory: "",
          },
          on: { change: _setup.handleChange },
        },
        _vm._l(_setup.items, function (item, i) {
          return _c(VRadio, {
            key: i,
            staticClass: "my-3",
            attrs: {
              value: item.value,
              "data-qa-value": item.value,
              "data-qa": "filter-visit-location-type",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "text-body-1 text--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t(item.name, _setup.options)) +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }